const TipoBtnFiltro = {
    MEUS_AGENDAMENTOS: 'MEUS_AGENDAMENTOS',
    PENDENCIAS: 'PENDENCIAS',
    ABERTOS: 'ABERTOS',
}

export default TipoBtnFiltro;
